import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Activity } from '@dal/core';


@Component({
  selector: 'dal-shared-mini-ui-activity-queue',
  templateUrl: './mini-activity-queue.component.html',
  styleUrl: './mini-activity-queue.component.scss',
})
export class MiniActivityQueueComponent {
  @Input() activities: Activity[] | null = [];

  @Output() closeActivity = new EventEmitter<void>();
  @Output() deleteActivity = new EventEmitter<Activity>();
  @Output() pauseActivity = new EventEmitter<Activity>();
  @Output() resumeActivity = new EventEmitter<Activity>();
  @Output() cancelActivity = new EventEmitter<Activity>();

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    iconRegistry.addSvgIcon(
      'arrow-repeat',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/arrow-repeat.svg')
    );
    iconRegistry.addSvgIcon(
      'exclamation-square-fill',
      sanitizer.bypassSecurityTrustResourceUrl(
        '/assets/icons/exclamation-square-fill.svg'
      )
    );
  }

  delete(activity: Activity) {
    this.deleteActivity.emit(activity);
  }

  pause(activity: Activity) {
    this.pauseActivity.emit(activity);
  }

  resume(activity: Activity) {
    this.resumeActivity.emit(activity);
  }

  cancel(activity: Activity) {
    this.cancelActivity.emit(activity);
  }

  closeModal() {
    this.closeActivity.emit();
  }
}
